import React, { ReactElement } from 'react';
export type RepliconNavigationTabProps = {
  tabInfo: any;
};
const RepliconNavigationTab = ({
  tabInfo
}: RepliconNavigationTabProps): ReactElement | null => {
  return tabInfo.href ? (
    tabInfo.innerHtml ? (
      <a
        href={tabInfo.href}
        dangerouslySetInnerHTML={{
          __html: tabInfo.innerHtml
        }}
      ></a>
    ) : (
      <a href={tabInfo.href}>{tabInfo.displayText}</a>
    )
  ) : null;
};

export default RepliconNavigationTab;
